// ConfirmSubscription.jsx
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import ConfirmationModal from "./ConfirmationModal";

const ConfirmSubscription = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setIsError(true);
      setErrorMessage("Chýba token na potvrdenie.");
      setIsLoading(false);
      return;
    }

    // Call the API to confirm the subscription
    const confirmSubscription = async () => {
      try {
        // Make the API call to your backend using the updated API URL
        const response = await fetch(
          `${API_BASE_URL}/confirm-subscription?token=${token}`
        );

        if (!response.ok) {
          throw new Error(`Server responded with ${response.status}`);
        }

        const data = await response.json();

        if (data.status === "success") {
          setIsLoading(false);
        } else {
          setIsError(true);
          setErrorMessage(
            data.message || "Nastala chyba pri potvrdzovaní odberu."
          );
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error confirming subscription:", error);
        setIsError(true);
        setErrorMessage("Nastala chyba pri potvrdzovaní odberu.");
        setIsLoading(false);
      }
    };

    confirmSubscription();
  }, [token]);

  const handleClose = () => {
    // Redirect to homepage
    navigate("/");
  };

  // If still loading, show a loading spinner or message
  if (isLoading) {
    return (
      <div className='flex items-center justify-center min-h-screen'>
        <div className='animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-inaqgold'></div>
      </div>
    );
  }

  // Instead of including HomePage, just render the modal
  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-70'>
      <ConfirmationModal
        isSuccess={!isError}
        errorMessage={errorMessage}
        onClose={handleClose}
      />
    </div>
  );
};

export default ConfirmSubscription;
